import './SkeletonPrimitives.css';

export function SkeletonBlock({className = ''}) {
  return <span className={`skeleton-block ${className}`} aria-hidden="true" />;
}

export function SkeletonPage({children, className = ''}) {
  return <div className={`skeleton-page ${className}`} aria-busy="true">{children}</div>;
}

export function SkeletonTextLines({count = 3, className = ''}) {
  return (
    <div className={`skeleton-text-lines ${className}`} aria-hidden="true">
      {Array.from({length: count}, (_, index) => (
        <SkeletonBlock key={index} className={`skeleton-text-line skeleton-text-line-${index + 1}`} />
      ))}
    </div>
  );
}

export function SkeletonImage({className = ''}) {
  return <div className={`skeleton-image ${className}`} aria-hidden="true" />;
}